/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Watch_OnlyInputs */

const en_val_watch_only = /** @type {(inputs: Val_Watch_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch Only`)
};

const es_val_watch_only = /** @type {(inputs: Val_Watch_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo reloj`)
};

const fr_val_watch_only = /** @type {(inputs: Val_Watch_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montre uniquement`)
};

const de_val_watch_only = /** @type {(inputs: Val_Watch_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur Uhr`)
};

const ja_val_watch_only = /** @type {(inputs: Val_Watch_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時計のみ`)
};

const zh_val_watch_only = /** @type {(inputs: Val_Watch_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅手表单品`)
};

const ar_val_watch_only = /** @type {(inputs: Val_Watch_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الساعة فقط`)
};

const id_val_watch_only = /** @type {(inputs: Val_Watch_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya Jam`)
};

const it_val_watch_only = /** @type {(inputs: Val_Watch_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo Orologio`)
};

const ru_val_watch_only = /** @type {(inputs: Val_Watch_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Только часы`)
};

const pt_val_watch_only = /** @type {(inputs: Val_Watch_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas Relógio`)
};

const ko_val_watch_only = /** @type {(inputs: Val_Watch_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시계 단품`)
};

/**
* | output |
* | --- |
* | "Watch Only" |
*
* @param {Val_Watch_OnlyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_watch_only = /** @type {((inputs?: Val_Watch_OnlyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Watch_OnlyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_watch_only(inputs)
	if (locale === "es") return es_val_watch_only(inputs)
	if (locale === "fr") return fr_val_watch_only(inputs)
	if (locale === "de") return de_val_watch_only(inputs)
	if (locale === "ja") return ja_val_watch_only(inputs)
	if (locale === "zh") return zh_val_watch_only(inputs)
	if (locale === "ar") return ar_val_watch_only(inputs)
	if (locale === "id") return id_val_watch_only(inputs)
	if (locale === "it") return it_val_watch_only(inputs)
	if (locale === "ru") return ru_val_watch_only(inputs)
	if (locale === "pt") return pt_val_watch_only(inputs)
	return ko_val_watch_only(inputs)
});